import { useSafeReturnTo } from '@hooks/return-to.hook';
import { useGetSurvey } from '@queries/survey.query';
import { isQuestionAnswered } from '@utils/survey.util';
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { SurveySection } from './section.component';

export const SurveyComponent: React.FC = () => {
  const { surveyId, technologyId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const chapterId = searchParams.get('chapterId') || undefined;
  const { returnToSearch } = useSafeReturnTo();
  const shouldViewFirstUnanswered = searchParams.get('viewFirstUnansweredQuestion') === 'true';
  const { data: survey } = useGetSurvey(surveyId);

  useEffect(() => {
    if (!survey) return;

    if (shouldViewFirstUnanswered) {
      // Find the first unanswered question in the earliest section
      for (const chapter of survey.snapshot.chapters) {
        for (const section of chapter.sections) {
          const firstUnansweredIndex = section.questions.findIndex((questionId) => {
            const question = survey.questions.find((q) => q.id === questionId);
            return !isQuestionAnswered({
              answers: survey.answers,
              questionId,
              questionType: question?.type,
              sectionId: section.id,
            });
          });

          if (firstUnansweredIndex !== -1) {
            navigate(`/technology/${technologyId}/survey/${surveyId}/section/${section.id}${returnToSearch}`);
            return;
          }
        }
      }
    }
  }, [navigate, returnToSearch, survey, shouldViewFirstUnanswered, surveyId, technologyId]);

  const currentChapter = survey?.snapshot.chapters.find((chapter) => chapter.id === chapterId);

  return (
    <div className="flex-1">
      {currentChapter?.sections && (
        <SurveySection
          answers={survey?.answers}
          chapters={survey?.snapshot.chapters}
          currentChapterId={chapterId}
          questions={survey?.questions}
          sections={currentChapter.sections}
        />
      )}
    </div>
  );
};
